module.exports = __webpack_public_path__ + "static/media/info.088322c7.svg";